import { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { SketchPicker } from 'react-color'
import { Button } from '@winnin/winnin_ui.components.button'

import { useOutsideClick } from 'hooks'
import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { DEFAULT_PICKER_COLORS } from './consts'
import './index.scss'

const ColorPickerWithActions = ({
  isOpen,
  closePicker,
  onSelect,
  currentColor,
  className = '',
  hideButtons = false,
  availableColors = DEFAULT_PICKER_COLORS,
}) => {
  const [selectedColor, setSelectedColor] = useState(currentColor || '')
  const ref = useRef(null)
  const { isClickOutside } = useOutsideClick(ref)

  const preventClick = e => {
    e?.preventDefault?.()
    e?.stopPropagation?.()
  }

  const handleOnSelect = () => {
    onSelect(selectedColor)
    closePicker()
  }

  const handleColorChange = ({ rgb: { r, g, b, a } }) => {
    const color = `rgba(${r}, ${g}, ${b}, ${a})`
    setSelectedColor(color)
    if (hideButtons) {
      onSelect(color)
    }
  }

  useEffect(() => {
    if (isClickOutside) {
      closePicker()
    }

    // eslint-disable-next-line
  }, [isClickOutside])

  if (!isOpen) {
    return null
  }

  return (
    <div
      ref={ref}
      aria-haspopup="true"
      aria-expanded="true"
      aria-label="rdw-color-picker"
      className={classNames('ColorPickerWithActions', className)}
    >
      <div className="ColorPickerWithActions-picker-wrapper" onClick={preventClick}>
        <SketchPicker presetColors={availableColors} color={selectedColor} onChange={handleColorChange} />
      </div>

      {!hideButtons && (
        <div className="ColorPickerWithActions-actions">
          <Button appearance="link" onClick={closePicker}>
            <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
          </Button>

          <Button onClick={handleOnSelect}>
            <T keyName={TOLGEE_GLOBALS.choose.key}>{TOLGEE_GLOBALS.choose.defaultValue}</T>
          </Button>
        </div>
      )}
    </div>
  )
}

export default ColorPickerWithActions
